import FormikInputGroup from 'components/formikFields/inputGroup';
import {Form, Formik} from 'formik';
import {useParams} from 'react-router-dom';
import {existingUnits} from 'utilities/helper/existingUnitsOption';
import {schema} from './utilities/validationSchema';
import useSetPrepaymentSuggest from '../hooks/useSetPrepaymentSuggest';
import {unitToPersian} from 'utilities/helper/unitToPersian';

const OfferForm = ({setIsOpen, price, app}: IOfferFormProps) => {
  const params = useParams();
  const {isLoading, mutate} = useSetPrepaymentSuggest(setIsOpen);
  return (
    <>
      <div className=" pt-2 px-3">
        <div className="flex justify-end">
          <span className="icon-close" onClick={() => setIsOpen(false)}></span>
        </div>
        <p className="text-gray-6">
          مقدار محصولی که در ازای مشارکت در تامین مالی دریافت ‌می‌کنید را تعیین
          کنید.
        </p>
        <Formik
          initialValues={{amount: '', amount_unit: existingUnits[0].value}}
          validationSchema={schema}
          onSubmit={values => {
            const payload: IPrepaymentSuggestProps = {
              amount: values.amount,
              amount_unit: values.amount_unit,
              profile_type: app,
              post_guid: params.guid,
            };
            !isLoading && mutate(payload);
          }}
        >
          {({values}) => (
            <Form>
              <div className="mt-6">
                <FormikInputGroup
                  name="amount"
                  label="مقدار محصول"
                  Options={existingUnits}
                  optionName="amount_unit"
                  type="number"
                />
              </div>
              <div className="mt-6 flex justify-between">
                <div>
                  <p className="text-gray-6">
                    قیمت به ازای هر {unitToPersian[values.amount_unit]}:
                  </p>
                </div>
                <p className="text-gray-6">
                  {values.amount && (price / Number(values.amount)).toFixed(2)}{' '}
                  تومان
                </p>
              </div>
              <div className="mt-8">
                <button
                  type="submit"
                  className=" w-full text-white bg-primary py-4 rounded-lg mb-6"
                >
                  ارسال پیشنهاد
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default OfferForm;
